import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
const IconWarningOutline = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-label="IconWarningOutline"
    fill="currentColor"
    ref={ref}
    {...props}
  >
    <path d="M1.027 22.5a.95.95 0 0 1-.543-.154.9.9 0 0 1-.33-.366.78.78 0 0 1-.153-.459.87.87 0 0 1 .152-.525l11-19.004a.9.9 0 0 1 .37-.369Q11.753 1.5 12 1.5t.478.123.395.37l11.001 19.003a1 1 0 0 1 .125.525.9.9 0 0 1-.125.46 1.4 1.4 0 0 1-.37.36.87.87 0 0 1-.504.159zm1.72-1.996h18.507L12 4.508zm9.386-1.422a.94.94 0 0 0 .7-.291.96.96 0 0 0 .286-.698.98.98 0 0 0-.291-.706.95.95 0 0 0-.705-.301q-.412 0-.705.3a1 1 0 0 0-.292.716q0 .406.297.693a.99.99 0 0 0 .71.287m0-3.336a.95.95 0 0 0 .7-.29.99.99 0 0 0 .286-.722v-4.183q0-.405-.291-.694a.96.96 0 0 0-.705-.29.96.96 0 0 0-.705.29.95.95 0 0 0-.292.694v4.183q0 .43.297.722.296.29.71.29" />
  </svg>
);
const ForwardRef = /* #__PURE__ */ forwardRef(IconWarningOutline);
const Memo = /* #__PURE__ */ memo(ForwardRef);
export default Memo;
